import React from 'react';
import FacebookLogin from 'react-facebook-login';
import { createUseStyles } from 'react-jss';

import { facebookLogin } from '../services/ApiService';

export interface LoginFacebookProps {
    success: Function
}

const LoginFacebook: React.FC<LoginFacebookProps> = ({ success }) => {
    const classes = useStyles();



    const responseFacebook = (res: any) => {
        console.log(res)
        return (async () => {
            let body = {
                "provider_id": res.userID,
                "name": res.name,
                "email": res.email,
                "social_photo": res.picture.data.url
            };
            let data = await facebookLogin(body);
            data['socialPhoto'] = res.picture.data.url;
            success(data)
        })()
    }
    return (
        <div className={classes.btnFacebookContainer}>
            <FacebookLogin
                appId="1671173566245525"
                autoLoad={false}
                fields="name,email,picture"
                callback={responseFacebook}
                cssClass={classes.facebookBtn}
                icon="fa-facebook"
            />
        </div>
    )
}

const useStyles = createUseStyles({

    "facebookBtn": {
        width: "184px",
        height: "42px",
        position: "relative",
        border: "0px",
        backgroundColor: "#0d8bf0",
        borderRadius: "2px",
        paddingLeft: "40px",
        fontWeight: "bold",
        boxShadow: "0 3px 4px 0 rgba(0, 0, 0, 0.25)",
        color: "#fff",
        fontSize: "14px",
        letterSpacing: "0.2px",
        fontFamily: "Roboto",
        "& i": {
            position: "absolute",
            marginTop: "1px",
            marginTeft: "1px",
            width: "40px",
            height: "40px",
            backgroundColor: "#0d8bf0",
            fontSize: "22px",
            paddingTop: "10px",
            borderRadius: "2px",
            top: "0px",
            left: "0px",
        },
        "&:hover": {
            boxShadow: "0 0 6px #4285f4",
            cursor: "pointer"
        },
        "&:active": {
            // background: "#1669f2"
        }
    },
    "btnFacebookContainer": {

    },
    '@media(max-width:580px)': {
        "btnFacebookContainer": {
            marginBottom: '10px',

        },
        "facebookBtn":
        {
            width: '200px',
        }
    },
})

export default LoginFacebook

